import React from "react";

import { IgButton } from "@intelligems/ig-theme";
import { EmbeddedPreviewError } from "@src/features/experienceBuilder/pageState/EmbeddedPreviewError";
import { useDispatch } from "@src/store";
import {
  ExperienceBuilderAction,
  ExperienceBuilderSelector,
} from "@src/store/slices/experienceBuilder";
import { v4 } from "uuid";
import { useSelector } from "react-redux";

export const PluginCacheInvalidError = () => {
  const dispatch = useDispatch();
  const onReload = () => dispatch(ExperienceBuilderAction.setCacheKey(v4()));
  const isPageLoading = useSelector(ExperienceBuilderSelector.isPageLoading);

  return (
    <EmbeddedPreviewError
      title={"Intelligems Bundle Cache Mismatch"}
      description={
        "The Intelligems bundle on your website is incorrectly cached. Please reload"
      }
      buttons={
        <IgButton
          variant="contained"
          color="warning"
          onClick={onReload}
          loading={isPageLoading}
          sx={{ flex: 1 }}
        >
          Reload
        </IgButton>
      }
    />
  );
};
